import {
  type PropsWithChildren,
  useEffect,
  useMemo,
} from "react";
import { LangContext } from "../contexts/LangContext";
import { type AvailableLocales, availableLocales, loadCatalog } from "../i18n";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import type { LanguageKey } from "@op/puck-types";

export interface LangProviderProps extends PropsWithChildren {
  languageKey: LanguageKey;
}

export const LangProvider = ({ children, languageKey }: LangProviderProps) => {
  const isValidLanguageKey = useMemo(
    () => availableLocales.includes(languageKey as any),
    [languageKey]
  );

  const currentLang = useMemo(
    (): AvailableLocales =>
      isValidLanguageKey ? (languageKey as AvailableLocales) : "en",
    [isValidLanguageKey]
  );

  useEffect(() => {
    loadCatalog(currentLang);
  }, [currentLang]);

  return (
    <LangContext.Provider value={{ currentLang }}>
      <I18nProvider i18n={i18n as any}>{children}</I18nProvider>
    </LangContext.Provider>
  );
};
